import { loginPageObject } from "../utils/pageObjects/login.pageObject"
import { clarity } from "./clarityInitializer"

export const loginEventsMap = (): Map<HTMLElement | null, () => void> => {
    const existentClarity = clarity
    if (!existentClarity) {
        return new Map<HTMLElement | null, () => void>([])
    }

    const pageObject = loginPageObject()

    return new Map([
        [
            pageObject.appleLoginButton,
            () => {
                existentClarity.setCustomEvent("appleLoginClick")
            }
        ],
        [
            pageObject.googleLoginButton,
            () => {
                existentClarity.setCustomEvent("googleLoginClick")
            }
        ],
        [
            pageObject.submitPasswordlessIdButton,
            () => {
                existentClarity.setCustomEvent("submitPasswordlessClick")
            }
        ],
        [
            pageObject.submitWithPasswordButton,
            () => {
                existentClarity.setCustomEvent("submitWithPasswordClick")
            }
        ],
        [
            pageObject.resendCodePasswordlessButton,
            () => {
                existentClarity.setCustomEvent("resendCodePasswordlessClick")
            }
        ],
        [
            pageObject.switchFromPasswordlessToPasswordButton,
            () => {
                existentClarity.setCustomEvent(
                    "switchFromPasswordlessToPasswordClick"
                )
            }
        ],
        [
            pageObject.forgotPasswordLink,
            () => {
                existentClarity.setCustomEvent("forgotPasswordClick")
            }
        ],
        [
            pageObject.returnPasswordlessNav,
            () => {
                existentClarity.setCustomEvent("returnPasswordlessClick")
            }
        ],
        [
            pageObject.submitPasswordlessCodeButton,
            () => {
                existentClarity.setCustomEvent("submitPasswordlessCodeClick")
            }
        ]
    ])
}
